/* ===== Shopify variant IDs — cart permalinks go straight to checkout ===== */
const VARIANTS = {
  1:{banana:48566565994714, strawberry:48566566027482, carrot:48566566060250},
  2:{banana:48566566093018, strawberry:48566566125786, carrot:48566566158554},
  3:{all:48566566191322}
};
let currentFlavor="banana";

/* ---------- gallery ---------- */
const stageImg=document.getElementById("stage-img");
function setStage(src){ stageImg.src=src; document.querySelectorAll(".thumbs button").forEach(b=>b.setAttribute("aria-selected",String(b.dataset.src===src))); }
document.querySelectorAll(".thumbs button").forEach(b=>b.addEventListener("click",()=>setStage(b.dataset.src)));
document.getElementById("stage-fig").addEventListener("click",()=>openLightbox(stageImg.src));

/* ---------- variants ---------- */
document.querySelectorAll("#variants button").forEach(b=>b.addEventListener("click",()=>{
  document.querySelectorAll("#variants button").forEach(x=>x.setAttribute("aria-pressed","false"));
  b.setAttribute("aria-pressed","true");
  currentFlavor=b.dataset.variant; document.getElementById("variant-name").textContent=b.dataset.variant[0].toUpperCase()+b.dataset.variant.slice(1);
  setStage(b.dataset.src);
}));

/* ---------- bundles / pricing ---------- */
let current={bundle:3,price:"39.99",compare:"59.97",label:"Full Trio"};
const fmt=n=>"$"+n;
const TRIO_IMG=document.querySelectorAll(".thumbs button")[1].dataset.src;
function applyBundle(btn){
  document.querySelectorAll(".bundle").forEach(x=>x.setAttribute("aria-pressed","false"));
  btn.setAttribute("aria-pressed","true");
  current={bundle:+btn.dataset.bundle,price:btn.dataset.price,compare:btn.dataset.compare,label:btn.dataset.label};
  document.getElementById("cta").textContent=`Add to cart — ${current.label} · ${fmt(current.price)}`;
  document.getElementById("cta-final").textContent=`Get my MeloMates — ${fmt(current.price)}`;
  document.getElementById("sticky-price").textContent=fmt(current.price);
  document.getElementById("sticky-compare").textContent=fmt(current.compare);
  document.getElementById("sticky-label").textContent=current.label;
  if(current.bundle===3) setStage(TRIO_IMG);
}
document.querySelectorAll(".bundle").forEach(b=>b.addEventListener("click",()=>applyBundle(b)));

/* ---------- checkout ---------- */
function toast(msg){const t=document.getElementById("toast");t.textContent=msg;t.classList.add("show");clearTimeout(t._h);t._h=setTimeout(()=>t.classList.remove("show"),3200);}
function checkout(){
  const id = current.bundle===3 ? VARIANTS[3].all : VARIANTS[current.bundle][currentFlavor];
  if(!id){ toast("Something went wrong — please try again."); return; }
  location.href = "/cart/"+id+":1";
}
["cta","cta-final","cta-sticky"].forEach(id=>document.getElementById(id).addEventListener("click",checkout));

/* ---------- sticky bar ---------- */
const buy=document.getElementById("buy"),bar=document.getElementById("sticky-bar");
new IntersectionObserver(e=>bar.classList.toggle("show",!e[0].isIntersecting&&e[0].boundingClientRect.top<0),{threshold:0}).observe(buy);

/* ---------- reviews: show more + lightbox ---------- */
document.getElementById("more-reviews").addEventListener("click",e=>{document.querySelectorAll(".review.hidden").forEach(r=>r.classList.remove("hidden"));e.target.remove();});
const lb=document.getElementById("lightbox"),lbImg=document.getElementById("lightbox-img");
function openLightbox(src){lbImg.src=src;lb.classList.add("show");}
lb.addEventListener("click",()=>lb.classList.remove("show"));
document.addEventListener("keydown",e=>{if(e.key==="Escape")lb.classList.remove("show");});
document.querySelectorAll("[data-full]").forEach(b=>b.addEventListener("click",()=>openLightbox(b.dataset.full)));

/* ---------- touch demo (WebAudio) ---------- */
const padA=document.getElementById("pad-a"),padB=document.getElementById("pad-b"),link=document.getElementById("pad-link"),status=document.getElementById("demo-status");
let ctx=null,seq=null,down={a:false,b:false};
const MELODY=[523.25,587.33,659.25,783.99,659.25,587.33,523.25,392.0,523.25,659.25,783.99,1046.5];
function note(freq,t,dur){const o=ctx.createOscillator(),g=ctx.createGain();o.type="triangle";o.frequency.value=freq;g.gain.setValueAtTime(0,t);g.gain.linearRampToValueAtTime(.22,t+.02);g.gain.exponentialRampToValueAtTime(.001,t+dur);o.connect(g).connect(ctx.destination);o.start(t);o.stop(t+dur+.05);}
function startMusic(){if(!ctx)ctx=new (window.AudioContext||window.webkitAudioContext)();if(ctx.state==="suspended")ctx.resume();let i=0;const step=()=>{note(MELODY[i%MELODY.length],ctx.currentTime,.34);i++;};step();seq=setInterval(step,300);link.classList.add("lit");status.textContent="🎶 Connected! This is the magic — now imagine it's a hug.";}
function stopMusic(){if(seq){clearInterval(seq);seq=null;}link.classList.remove("lit");status.textContent="Press both pads at once 🎶";}
function update(){const both=down.a&&down.b;padA.classList.toggle("active",down.a);padB.classList.toggle("active",down.b);if(both&&!seq)startMusic();if(!both&&seq)stopMusic();if(!both&&(down.a||down.b))status.textContent="One more! Hold the other pad too 👆";}
function bind(pad,key){const on=e=>{e.preventDefault();down[key]=true;update();};const off=()=>{down[key]=false;update();};pad.addEventListener("pointerdown",on);["pointerup","pointercancel","pointerleave"].forEach(ev=>pad.addEventListener(ev,off));pad.addEventListener("keydown",e=>{if(e.key===" "||e.key==="Enter"){e.preventDefault();down[key]=!down[key];update();}});}
bind(padA,"a");bind(padB,"b");
